import { useRef } from 'react';

export type OsPlatform = 'windows' | 'not-windows';

type NavigatorWithUAData = Navigator & { userAgentData?: { platform: string } };

function detectOsPlatform(): OsPlatform {
  // 1. SSR safety
  if (typeof navigator === 'undefined') return 'not-windows';

  // 2. Modern API — use exclusively when available
  const uaData = (navigator as NavigatorWithUAData).userAgentData;
  if (uaData) {
    return uaData.platform === 'Windows' ? 'windows' : 'not-windows';
  }

  // 3. Legacy fallback
  return /win/i.test(navigator.userAgent) ? 'windows' : 'not-windows';
}

/**
 * Synchronously determines the OS platform on first render.
 * Returns 'windows' or 'not-windows' without causing a re-render.
 */
export function useWindowsOrNot(): OsPlatform {
  const platform = useRef<OsPlatform>(detectOsPlatform());
  return platform.current;
}
